import { render } from "./zsActivitySignInfo.vue?vue&type=template&id=0a1fe765&scoped=true"
import script from "./zsActivitySignInfo.vue?vue&type=script&lang=js"
export * from "./zsActivitySignInfo.vue?vue&type=script&lang=js"

import "./zsActivitySignInfo.vue?vue&type=style&index=0&id=0a1fe765&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1fe765"]])

export default __exports__